import { type Framework } from '@toeverything/infra';

import { GlobalCache } from '../storage';
import { WorkspaceScope, WorkspaceService } from '../workspace';
import { NavigationPanelService } from './services/navigation-panel';
export {
  getNavigationPanelRootSectionFallback,
  NAVIGATION_PANEL_ROOT_SECTIONS,
  type NavigationPanelRootSection,
  NavigationPanelService,
} from './services/navigation-panel';

export function configureNavigationPanelModule(framework: Framework) {
  framework
    .scope(WorkspaceScope)
    .service(NavigationPanelService, [GlobalCache, WorkspaceService]);
}
